import $ from "jquery";
import dayjs from "dayjs";
import 'daterangepicker-use-dayjs';
import "daterangepicker-use-dayjs/daterangepicker.css";

// Plugins
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import arraySupport from "dayjs/plugin/arraySupport";
import badMutable from "dayjs/plugin/badMutable";

// Load plugins
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek);
dayjs.extend(arraySupport);
dayjs.extend(badMutable);

// Simple Date Range Picker
$('[data-plugin="daterangepicker"]').daterangepicker({
    locale: {
        format: "YYYY-MM-DD"
    },
    ranges: {
        Today: [dayjs(), dayjs()],
        Yesterday: [dayjs().subtract(1, "days"), dayjs().subtract(1, "days")],
        "Last 7 Days": [dayjs().subtract(6, "days"), dayjs()],
        "Last 30 Days": [dayjs().subtract(29, "days"), dayjs()],
        "This Month": [dayjs().startOf("month"), dayjs().endOf("month")],
        "Last Month": [
            dayjs().subtract(1, "month").startOf("month"),
            dayjs().subtract(1, "month").endOf("month")
        ]
    },
});
